import { withStyles } from '@material-ui/core';
import TypeBadge from './TypeBadge';
import styles from './styles';

export default withStyles(styles)(TypeBadge);
